import Loadable from '../../../components/loadable';

export default Loadable(() =>
  import(/* webpackChunkName: "layout-bottom" */ './index')
);
